module.exports = __webpack_public_path__ + "img/location-setting-iphone.6806044c.png";